import { UseFormReturn } from 'react-hook-form'
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { documentTypeOptions } from '@/lib/document-types'

interface DocumentFormProps {
  form: UseFormReturn<any>
  required?: string[]
}

/**
 * Componente reutilizable para documento de identidad
 * Uso: <DocumentForm form={form} required={['num_document']} />
 */
export function DocumentForm({ form, required = [] }: DocumentFormProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <FormField
        control={form.control}
        name="tipus_document"
        render={({ field }) => (
          <FormItem>
            <FormLabel>
              Tipus de Document {required.includes('tipus_document') && <span className="text-destructive">*</span>}
            </FormLabel>
            {/* Controlat: els modals d'edició fan `form.reset` després de muntar-se, i un
                `defaultValue` no ho veuria. Codis dels Mossos i, si n'hi ha, el valor desat (Cuentica) */}
            <Select onValueChange={field.onChange} value={field.value ?? ''}>
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder="Selecciona..." />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {documentTypeOptions(field.value).map((tipus) => (
                  <SelectItem key={tipus.value} value={tipus.value}>
                    {tipus.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="num_document"
        render={({ field }) => (
          <FormItem>
            <FormLabel>
              Número de Document {required.includes('num_document') && <span className="text-destructive">*</span>}
            </FormLabel>
            <FormControl>
              <Input {...field} placeholder="12345678A" />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  )
}
